module.exports = __webpack_public_path__ + "static/privacy-ed4a308ef03555934d9c496fb24fe89d.jpg";